module.exports = __webpack_public_path__ + "img/folder_solution_package_app_2.645f58b2.png";